var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100 text-center py-1 mb-2 "},[(_vm.hasExistingImage)?_c('img',{staticClass:"p-2 img-preview img-preview-existing",attrs:{"src":_vm.entity.medias[_vm.data.id].url.full}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }